import { defineMessage } from 'services/localization';

export const messages = {
    doneButtonText: defineMessage('send'),
    titleSubject: defineMessage('subject'),
    descriptionSubject: defineMessage('description'),
    filesHeader: defineMessage('attachments'),
    ButtonText: defineMessage('add_an_attachment'),
    dropHereText: defineMessage('drop_the_files_here'),
    popupTitle: defineMessage('contact_support_1'),
    doneButtonTitle: defineMessage('send_the_support_request'),
    fileTooBigError: defineMessage('sorry_the_file_filename_maximum_size_of_maxsize'),
    fileExtensionNotSupportedError: defineMessage('sorry_the_submitted_file_type_is_not_supported'),
    maxNumberOfAttachmentsExceeded: defineMessage('sorry_you_cannot_attach_than_files_to_a_comment'),
    validationErrorRequired: defineMessage('please_fill_in_the_required_fields_1'),
    postErrorResult: defineMessage('some_error_occurred'),
    postSuccessResult: defineMessage('the_support_request_has__successfully_submitted'),
    subjectPlaceholder: defineMessage('enter_a_subject'),
    descriptionPlaceholder: defineMessage('please_provide_a_stepby_scription_of_your_issue'),
};
